import apiClient from './apiClient'

export const actionNames = {
  INIT_PROJECTS: 'initProjects',
  CREATE_PROJECT: 'createProject',
  RENAME_PROJECT: 'renameProject',
  DELETE_PROJECT: 'deleteProject'
}

export const module = {
  state: {
    projects: []
  },
  mutations: {
    setProjects (state, newProjects) {
      state.projects = newProjects
    },
    addProject (state, newProject) {
      state.projects = [...state.projects, newProject]
    },
    renameProjectById (state, { name, projectId }) {
      state.projects = state.projects.map(p => {
        return p.id === projectId ? { ...p, name } : p
      })
    },
    deleteProjectById (state, projectToDelete) {
      state.projects = state.projects.filter(key => key.id !== projectToDelete)
    }
  },
  actions: {
    async [actionNames.INIT_PROJECTS] ({ commit, rootState }) {
      commit('setProjects', await apiClient.getProjects(rootState.auth.clientId))
    },
    async [actionNames.CREATE_PROJECT] ({ commit, rootState }, name) {
      commit('addProject', await apiClient.createProject(rootState.auth.clientId, name))
    },
    async [actionNames.RENAME_PROJECT] ({ commit, rootState }, { name, projectId }) {
      await apiClient.updateProject(rootState.auth.clientId, { name, projectId })
      commit('renameProjectById', { name, projectId })
    },
    async [actionNames.DELETE_PROJECT] ({ commit, rootState }, projectId) {
      await apiClient.deleteProject(rootState.auth.clientId, projectId)
      commit('deleteProjectById', projectId)
    }
  }
}
